import { Viewport } from '../../utils/viewport';
import { loadLottieScript } from '../../utils/scripts';
import { mqLaptop, mqTabletLandscape, mqTabletPortrait, mqPhone } from '../../utils/mq';

class LottieBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.wrapper = block.querySelector('.lottie__wrapper');
    this.viewport = new Viewport({ rootMargin: '-20%' });

    this.init().then(() => {
      this.viewport.observe(this.block, (block) => {
        if (this.animation) {
          this.animation.play();
        }
      });

      if (mqLaptop.addEventListener) {
        mqLaptop.addEventListener('change', () => this.resize());
        mqTabletLandscape.addEventListener('change', () => this.resize());
        mqTabletPortrait.addEventListener('change', () => this.resize());
        mqPhone.addEventListener('change', () => this.resize());
      } else {
        mqLaptop.addEventListener(() => this.resize());
        mqTabletLandscape.addEventListener(() => this.resize());
        mqTabletPortrait.addEventListener(() => this.resize());
        mqPhone.addEventListener(() => this.resize());
      }

      this.resize();
    });
  }

  async init() {
    if (this.wrapper.dataset.file) {
      await loadLottieScript().then(() => {
        this.animation = bodymovin.loadAnimation({
          container: this.wrapper,
          path: this.wrapper.dataset.file,
          renderer: 'svg',
          loop: !!this.wrapper.dataset.loop,
          autoplay: false,
        });
      });
    }
  }

  resize() {
    let maxWidth = this.wrapper.dataset.maxWidth ? this.wrapper.dataset.maxWidth : null;

    if (mqPhone.matches) {
      maxWidth = this.wrapper.dataset.maxWidthPh ? this.wrapper.dataset.maxWidthPh : maxWidth;
    } else if (mqTabletPortrait.matches) {
      maxWidth = this.wrapper.dataset.maxWidthTp ? this.wrapper.dataset.maxWidthTp : maxWidth;
    } else if (mqTabletLandscape.matches) {
      maxWidth = this.wrapper.dataset.maxWidthTl ? this.wrapper.dataset.maxWidthTl : maxWidth;
    } else if (mqLaptop.matches) {
      maxWidth = this.wrapper.dataset.maxWidthLp ? this.wrapper.dataset.maxWidthLp : maxWidth;
    }

    if (maxWidth) {
      this.wrapper.style.maxWidth = maxWidth + 'px';
    }
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.lottie').forEach((block) => {
  new LottieBlock(block);
});

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview/type=lottie', ($block, attributes) => {
    new LottieBlock($block.find('.lottie').get(0), attributes);
  });
}